import styled from "styled-components";
import Box from "./Box";
import { grid } from "styled-system";

const Gridbox = styled(Box)`
  display: grid;
  ${grid}
`;

export default Gridbox;
